import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=7c67ca70&scoped=true&"
import script from "./QuestionDetails.vue?vue&type=script&lang=js&"
export * from "./QuestionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c67ca70",
  null
  
)

export default component.exports